<template>
  <div class="row">
    <div class="col-md-4" v-for="e of experiences" :key="e.id">
      <ExperienceCard :e="e"></ExperienceCard>
    </div>
  </div>
</template>

<script>
import IrealVue from "ireal-vue";
import ExperienceCard from "@/components/ExperienceCard.vue";

export default {
  name: "ExperienceTypeChooser",
  props: ["institution_filter"],
  components: { ExperienceCard },
  mixins: [IrealVue.httpMixin],
  data() {
    return {
      experiences: [],
      locales: [
        { id: "en", name: "English", icon: "../assets/english.png" },
        { id: "fr", name: "Français", icon: "../assets/france.png" }
      ],
      currentLocale: "en"
    };
  },
  filters: {
    truncate: function(value, limit) {
      if (value.length > limit) {
        value = value.substring(0, limit - 3) + "...";
      }

      return value;
    }
  },
  async created() {
    // we use httpMixin. request to have the list of experience. Fill array "experience" with results.
    this.experiences = await this.getObjectList("experience");
  }
};
</script>
<style scoped>
.wrapper {
  margin: 15px;
}
</style>
